export default __webpack_public_path__ + "static/media/khelptranslate.d9c3b470.png";